import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { ErrorBoundary } from "react-error-boundary";
import cc from "classcat";
import reduxStore from "../../providers/reduxProvider";
import ApplicationErrorHandler from "../errors/ApplicationErrorHandler";
import Router from "../router/Router";
import TooltipProvider from "../uikit/Tooltip/TooltipProvider";
import CookiebotManager from "./CookiebotManager";
import LaravelEchoContextProvider from "./LaravelEchoContextProvider";
import ScreenWidthUpdater from "./ScreenWidthUpdater";
import AuthManager from "../auth/AuthManager";
import FlashMessengerProvider from "../uikit/FlashMessenger/FlashMessengerProvider";
import FlashMessenger from "../uikit/FlashMessenger/FlashMessenger";
import useDarkMode from "../../hooks/useDarkMode";
import ApplicationLoaderProvider from "./ApplicationLoaderContext";
import LanguageLoaderProvider from "../intl/LanguageLoaderProvider";
import GoogleTagManager from "./GoogleTagManager";
import CrispChat from "./CrispChat";
export default function App() {
    var darkMode = useDarkMode();
    return(// <React.StrictMode>
    /*#__PURE__*/ React.createElement(ErrorBoundary, {
        FallbackComponent: ApplicationErrorHandler
    }, /*#__PURE__*/ React.createElement(Provider, {
        store: reduxStore
    }, /*#__PURE__*/ React.createElement(LaravelEchoContextProvider, null, /*#__PURE__*/ React.createElement(ApplicationLoaderProvider, null, /*#__PURE__*/ React.createElement(TooltipProvider, null, /*#__PURE__*/ React.createElement(FlashMessengerProvider, null, /*#__PURE__*/ React.createElement(HelmetProvider, null, /*#__PURE__*/ React.createElement(Helmet, {
        titleTemplate: "%s | RoBill",
        defaultTitle: "RoBill"
    }, /*#__PURE__*/ React.createElement("html", {
        className: cc([
            "h-screen",
            {
                dark: darkMode
            }
        ])
    }), /*#__PURE__*/ React.createElement("body", {
        className: cc([
            "min-h-full bg-gray-100 dark:bg-blue-900"
        ])
    })), /*#__PURE__*/ React.createElement(FlashMessenger, null), /*#__PURE__*/ React.createElement(LanguageLoaderProvider, null, /*#__PURE__*/ React.createElement(GoogleTagManager, null), /*#__PURE__*/ React.createElement(CookiebotManager, null), /*#__PURE__*/ React.createElement(AuthManager, null, /*#__PURE__*/ React.createElement(CrispChat, null), /*#__PURE__*/ React.createElement(Router, null))))))), /*#__PURE__*/ React.createElement(ScreenWidthUpdater, null)))));
}
